
<div class="signup">
  <section>
    <a href="https://www.cardladder.com">
      <full-logo pro />
    </a>

    <div class="form-container">
      <div class="title secondary-font">
        <h3>Go Pro for only <span class="success">{{ topPriceDisplay }}</span></h3>
        <h5 v-if="!needsConsent">
          With a 7-day free trial!
        </h5>
        <br v-else />
      </div>

      <div v-if="hasUserContext" class="user-context">
        <align flex small-gap>
          <div class="logged-in-context">
            <icon class="icon" name="check_circle" />
            <span>Signed in with {{ loggedInProvider }}</span>
          </div>

          <icon-button icon="close" @click="clearAuth" />
        </align>
      </div>

      <div>
        <div v-if="!hasUserContext" class="account-creation">
          <line-separator>
            SETUP YOUR LOGIN
          </line-separator>

          <auth-form v-model="form" />

          <line-separator v-show="!hideSocialAuth">
            OR
          </line-separator>

          <social-auth v-show="!hideSocialAuth" type="signup" />
        </div>

        <div v-show="!isCollectorsSignup" class="payment-entry">
          <line-separator>
            ENTER YOUR PAYMENT
          </line-separator>

          <div v-show="!giftCardObject || !giftCardObject.valid" class="options">
            <div
              :class="['option', { active: subscriptionType === 'monthly' }]"
              @click="subscriptionType = 'monthly'"
            >
              <div :class="['price', { strikethrough: monthlyPrice !== monthly.price }]">
                {{ monthly.priceDisplay }}
              </div>

              <div v-if="monthlyPrice !== monthly.price" class="price">
                {{ $filters.currency(monthlyPrice) }}/mo
              </div>

              <div v-if="!hasValidPromo" class="save">
                <small>MOST FLEXIBLE</small>
              </div>
            </div>

            <div
              :class="['option', { active: subscriptionType === 'annual' }]"
              @click="subscriptionType = 'annual'"
            >
              <div :class="['price', { strikethrough: annualPrice !== annual.price }]">
                {{ annual.priceDisplay }}
              </div>

              <div v-if="annualPrice !== annual.price" class="price">
                {{ $filters.currency(annualPrice) }}/yr
              </div>

              <div v-if="!hasValidPromo" class="save">
                <small>SAVE 17%</small>
              </div>
            </div>
          </div>

          <div v-show="!checkingExistingPaymentMethod && !useExistingPayment" :class="['cc-container', { focus: elementFocus }]">
            <div id="card-element" class="MyCardElement" />
          </div>

          <align v-show="!checkingExistingPaymentMethod && useExistingPayment" flex class="existing-payment">
            <span>Use existing card x{{ existingLast4 }}</span>
            <icon-button icon="close" @click="useExistingPayment = false" />
          </align>

          <div v-show="!checkingExistingPaymentMethod && !useExistingPayment" class="stripe-image">
            <a href="https://stripe.com/privacy" target="_blank">
              <img
                height="24"
                alt="Powered by Stripe"
                src="@/assets/powered-by-stripe-blurple.svg"
              />
            </a>
          </div>
        </div>

        <payment-promo-result
          v-if="showPromoResult"
          :promo="promoObject"
          :is-monthly="isMonthly"
          @clear="clearPromo"
        />

        <div v-if="needsConsent" class="needs-consent">
          <p>It looks like you've already had a free trial with us and we will charge your card immediately for this subscription. If you'd like to still sign up please agree to being charged immediately.</p>
          <checkbox
            v-model="duplicateTrialConsent"
            label="I agree to my card being charged immediately"
          />
        </div>

        <div class="legal">
          <align>
            <checkbox v-model="agreeToTerms" />

            <p>
              By starting your subscription, you are agreeing to our
              <router-link to="/tos" target="_blank">
                terms of use
              </router-link>
              and <router-link to="/privacy" target="_blank">
                privacy policy
              </router-link>.
              <span>{{ pricingDescription }}</span>
            </p>
          </align>
        </div>

        <btn
          block
          :loading-text="loadingText"
          :loading="loading"
          :disabled="loading || !agreeToTerms"
          @click="submit"
        >
          {{ submitButtonText }}
        </btn>

        <div>
          <div class="links">
            <a v-if="hasUserContext" class="link" @click="logout">Logout</a>

            <a
              v-else
              class="link"
              @click="$router.push({ path: '/login', query: $route.query })"
            >
              Back to login
            </a>

            <span>|</span>

            <a
              class="link"
              @click="paymentPromoEntryOpen = true"
            >
              Have a promo code?
            </a>

            <span v-if="isMonthly">|</span>

            <a
              v-if="isMonthly"
              class="link"
              @click="giftCardEntryOpen = true"
            >
              Have a gift card?
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="banner">
    <div>
      <h1 class="secondary-font">
        With Card Ladder Pro,<br />you can:
      </h1>

      <div class="bullets">
        <align>
          <icon class="large-check" name="check_circle" />

          <h3 class="secondary-font">
            View all-time sales history for millions of cards
          </h3>
        </align>

        <align>
          <icon class="large-check" name="check_circle" />

          <h3 class="secondary-font">
            Upload your collection and get daily value estimates
          </h3>
        </align>

        <align>
          <icon class="large-check" name="check_circle" />

          <h3 class="secondary-font">
            Check estimated pricing for any card
          </h3>
        </align>

        <align>
          <icon class="large-check" name="check_circle" />

          <h3 class="secondary-font">
            View Full population reports for all graded cards
          </h3>
        </align>
      </div>

      <h3 class="secondary-font">
        And so much more...
      </h3>
    </div>
  </section>

  <portal to="fullscreen">
    <payment-promo-entry
      :open="paymentPromoEntryOpen"
      @close="paymentPromoEntryOpen = false"
      @submit="setPromo"
    />

    <gift-card-entry
      :open="giftCardEntryOpen"
      @close="giftCardEntryOpen = false"
      @submit="setGiftCard"
    />
  </portal>
</div>
